import { ParamType, getMobileSource } from '../../assets/helper';

import { DEVICE } from '../../views/Preview';
import { FunctionalComponent } from 'preact';
import { WrapperDiv } from './MobileDevice.styled';

type MobileDeviceProps = {
  device: DEVICE;
  urlParams: ParamType;
  useSandbox: boolean;
};

const MobileDevice: FunctionalComponent<MobileDeviceProps> = ({ device, urlParams, useSandbox }) => {
  return (
    <WrapperDiv>
      <iframe
        id="preview-app"
        src={getMobileSource(device, urlParams, useSandbox)}
        frameBorder="0"
        scrolling="no"
        width={device === DEVICE.IOS ? 345 : 305}
        height={680}
        title="preview-app"
      />
    </WrapperDiv>
  );
};

export default MobileDevice;
